// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7b2d3ae1","455":"58c27ef0","977":"fdd52348"}[chunkId] + ".chunk.js";
};